<template>
  <th class="text-center" width="60px">
    <v-select
      :items="sizes"
      item-value="key"
      item-text="name"
      label=""
      dense
      style="max-width: 50px; font-size: 15px"
      hide-details
      :menu-props="{
        bottom: true,
        offsetY: true,
        transition: 'scale-transition',
      }"
      single-line
      class="py-2 px-0"
      @change="changed"
      v-model="selected"
    >
    </v-select>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selected: [25],
      // sizes: [25, 50, 75, 100, 150, 200],
      sizes: [25, 50, 75, 100],
    };
  },
  methods: {
    ...mapGetters(["getPageSize"]),
    ...mapActions(["setPageSize"]),
    changed: function () {
      // console.log("Changed:" + this.selected);
      this.setPageSize({ value: this.selected });
      this.$emit("page_size_change");
    },
  },
  created() {
    let page_size = this.getPageSize();
    this.selected = page_size;
  },
};
</script>

<style scoped></style>
